import { render, staticRenderFns } from "./LawMap.vue?vue&type=template&id=1f9c8d38&scoped=true&"
import script from "./LawMap.vue?vue&type=script&lang=js&"
export * from "./LawMap.vue?vue&type=script&lang=js&"
import style0 from "./LawMap.vue?vue&type=style&index=0&id=1f9c8d38&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f9c8d38",
  null
  
)

export default component.exports